<template>
  <div class="nested-tree"
    :class="{
      'branch': children.length
    }">
    <div class="main" :class="{'leaf-value': data.type === 'value'}">
      <div class="name-wrap">
        <span class="name">{{ data.chineseInstructions }}</span>
      </div>
      <div class="ctrl" v-if="isValid">
        <a-button size="small" type="danger" v-if="movingAttr && movingAttr.id === data.id" @click="cancelMoving">取消移动</a-button>
        <a-button size="small" type="primary" v-if="movingAccpetable" @click="acceptMoving">移动至</a-button>
        <img v-if="!movingAttr" class="ctrl-icon" src="./edit.png" @click="handleEdit(data)">
        <a-dropdown v-if="!movingAttr">
          <a class="ant-dropdown-link" @click.prevent>
            <img class="ctrl-icon" src="./menu.png" alt="">
          </a>
          <template #overlay>
            <a-menu @click="clickMenu">
              <a-menu-item key="1" :disabled="data.type === 'value' || (children[0] && children[0].type === 'value')">
                <span>新增目录</span>
              </a-menu-item>
              <a-menu-item key="2" :disabled="data.type === 'value' || (children[0] && children[0].type === 'folder')">
                <span>新增属性值</span>
              </a-menu-item>
              <a-menu-item key="3">
                <span>删除</span>
              </a-menu-item>
              <a-menu-item key="4" v-if="data.type !== 'category'">
                <span>移动</span>
              </a-menu-item>
              <a-menu-item key="5" :disabled="!onlyChild || children.length">
                <span>类型转换</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </div>
    <div class="children" v-if="children && children.length">
      <nested-tree
        v-for="(item) in children"
        :key="item.id"
        :onlyChild="children.length === 1"
        :ref="setChildrenRef"
        :data="item"
        :childrens="item.children"
        @deleteChild="deleteChild"
        @updateChild="updateChild"
        @changeChildType="changeChildType"
        @updateAll="emitUpdateAll">
      </nested-tree>
    </div>
    <a-modal v-model:visible="inputVisible" title="请输入名称" @ok="modalConfirm"
      :confirmLoading="modalLoading"
      :maskClosable="false">
      <a-input v-model:value="inputValue" placeholder="请输入名称"></a-input>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {
  // getAttrValue,
  // getAttrSubValue,
  addAttrValue,
  deleteAttrValue,
  updateAttrCategory,
  updateAttrValue
} from '@/api/dataAttr'
const typeDic = {
  folder: '目录',
  value: '属性值'
}
export default {
  name: 'NestedTree',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    onlyChild: {
      type: Boolean,
      default: false
    },
    childrens: {
      type: Array,
      default: () => []
    }
  },
  emits: ['deleteChild', 'updateChild', 'updateAll'],
  data () {
    return {
      children: [],
      childrenRefs: [],
      modalType: 'add',
      inputValue: '',
      inputType: '',
      inputVisible: false,
      modalLoading: false
    }
  },
  computed: {
    ...mapState(['currentRole', 'movingAttr', 'childrenId']),
    isValid () {
      const invalid = ['10', '11']
      return this.currentRole && invalid.indexOf(this.currentRole.roleId) === -1
    },
    movingAccpetable () {
      if (this.data.chineseInstructions === 'alpha' && this.movingAttr) {
        const find = this.children.find(c => c.id === this.movingAttr.id)
        if (find) {
          console.log(1, find)
          console.log(2, this.movingAttr)
        }
      }
      return this.movingAttr && (this.data.type === 'category' || this.data.type === 'folder') &&
        this.movingAttr.id !== this.data.id &&
        this.data.parentId !== this.movingAttr.id &&
        !this.children.some(c => c.id === this.movingAttr.id || c.type !== this.movingAttr.type) &&
        this.childrenId.indexOf(this.data.id) === -1
    }
  },
  mounted () {
    this.getChildren()
  },
  methods: {
    getChildren () {
      this.children = this.childrens

      // if (this.data.type === 'category') {
      //   getAttrValue(this.data.id).then(res => {
      //     this.children = res.data.map.data.rows
      //   })
      // } else if (this.data.type === 'folder') {
      //   getAttrSubValue(this.data.id).then(res => {
      //     this.children = res.data.map.data.rows
      //   })
      // }
    },
    setChildrenRef (el) {
      this.childrenRefs.push(el)
    },
    clickMenu ({ item, key, keyPath }) {
      switch (key - 0) {
        case 1:
          this.handleAdd('folder')
          break
        case 2:
          this.handleAdd('value')
          break
        case 3:
          this.deleteSelf()
          break
        case 4:
          this.moveSelf()
          break
        case 5:
          this.changeType()
          break
        default:
          break
      }
    },
    handleAdd (type) {
      this.modalType = 'add'
      this.inputValue = ''
      this.inputVisible = true
      this.inputType = type
    },
    handleEdit (item) {
      this.modalType = 'edit'
      this.inputValue = item.chineseInstructions
      this.inputVisible = true
    },
    modalConfirm () {
      if (!this.checkInput()) {
        return
      }
      if (this.modalType === 'add') {
        const params = {
          type: this.inputType,
          chineseInstructions: this.inputValue
        }
        if (this.data.type === 'category') {
          params.itemKeyId = this.data.id
        } else {
          params.parentId = this.data.id
        }
        this.modalLoading = true
        addAttrValue(params).then(res => {
          const item = res.data.map.itemValue
          this.children.push(item)
          this.inputVisible = false
        }).finally(() => {
          this.modalLoading = false
        })
      } else {
        let action = updateAttrValue
        if (this.data.type === 'category') {
          action = updateAttrCategory
        }
        this.modalLoading = true
        action({
          id: this.data.id,
          chineseInstructions: this.inputValue
        }).then(res => {
          this.inputVisible = false
          this.$emit('updateChild', {
            id: this.data.id,
            chineseInstructions: this.inputValue
          })
        }).finally(() => {
          this.modalLoading = false
        })
      }
    },
    updateChild (params) {
      const item = this.children.find(i => i.id === params.id)
      if (item) {
        item.chineseInstructions = params.chineseInstructions
      }
    },
    changeChildType (params) {
      const item = this.children.find(i => i.id === params.id)
      if (item) {
        item.type = params.type
      }
    },
    checkInput () {
      if (!this.inputValue) {
        this.$message.error('名称不能为空')
        return false
      }
      return true
    },
    deleteSelf () {
      console.log('删除')
      const content = this.data.type === 'value' ? '删除后，其属性值将一并删除' : '删除后，其子属性及属性值将一并删除'
      this.$confirm({
        title: '确认删除',
        content: content,
        onOk: () => {
          this.$emit('deleteChild', this.data.id)
        }
      })
    },
    deleteChild (id) {
      deleteAttrValue(id).then(res => {
        const index = this.children.findIndex(i => i.id === id)
        this.children.splice(index, 1)
      })
    },
    moveSelf () {
      this.$store.commit('clearChildrenId')
      this.$store.commit('setMovingAttr', this.data)
      this.getChildrenId()
    },
    cancelMoving () {
      this.$store.commit('setMovingAttr', null)
    },
    acceptMoving () {
      const params = {
        id: this.movingAttr.id
      }
      if (this.data.type === 'category') {
        params.itemKeyId = this.data.id
        params.parentId = null
      } else if (this.data.type === 'folder') {
        params.itemKeyId = null
        params.parentId = this.data.id
      } else {
        return
      }
      updateAttrValue(params).then(res => {
        this.$store.commit('setMovingAttr', null)
        this.$emit('updateAll')
      })
    },
    getChildrenId () {
      const ids = this.children.map(c => c.id)
      this.$store.commit('addChildrenId', ids)
      if (this.children.length && this.childrenRefs.length) {
        this.childrenRefs.forEach(childComp => {
          childComp.getChildrenId()
        })
      }
    },
    emitUpdateAll () {
      this.$emit('updateAll')
    },
    changeType () {
      const toValue = this.data.type === 'folder' ? 'value' : 'folder'
      const fromText = typeDic[this.data.type]
      const toText = typeDic[toValue]
      this.$confirm({
        title: '类型转换',
        content: `由【${fromText}】转换为【${toText}】？`,
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          updateAttrValue({
            id: this.data.id,
            type: toValue
          }).then(res => {
            this.$emit('changeChildType', {
              id: this.data.id,
              type: toValue
            })
          })
        },
        onCancel () {
          console.log('cancel')
        }
      })
    }
  }
}
</script>
<style lang="less">
.nested-tree {
  position: relative;
  &.branch {
    margin-bottom: 0;
  }
  &:not(:last-child) {
    margin-bottom: 5px;
  }

  .main {
    display: flex;
    margin-right: 20px;
    .name-wrap {
      width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
      height: 30px;
      .name {

        height: 100%; line-height: 30px;
      }
    }
    .ctrl {
      .ctrl-icon {
        width: 30px; height: 30px;
        cursor: pointer;
      }
    }
    &.leaf-value {
      .name-wrap {
        .name {
          border: 2px solid #0C2366; box-sizing: border-box;
        }
      }
    }
  }
  .children {
    margin: 10px 0 0 45px;
  }
}
</style>
